import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'

import Header from '../header/header'
import Footer from '../footer/footer'
import { default as suggestions } from '../header/pages_tags.json';


import './layout.css'
import '../../styles/basics.css'
import '../../styles/rules.css'

const chatStyle = {
  position: 'fixed',
  padding: 'var(--s-2) var(--s-4)',
  paddingTop: 'var(--s-2)',
  paddingBottom: 'var(--s-2)',
  paddingLeft: 'var(--s-2)',
  paddingRight: 'var(--s-2)',
  zIndex: 2,
  bottom: 0,
  borderRadius: '4px 4px 0 0',
  color: 'white',
  background: '#696158',
  backgroundColor: 'var(--gray--1)',
  right: 'var(--s-3)'
}



const Layout = ({ children }) => {

  const [tags, setTags] = React.useState([]);

  React.useEffect(() => {    
      let pathName = window.location.pathname;
      setTags(suggestions.pages.filter((page) => (pathName === page.URL || (pathName + '/') === page.URL || pathName === page.URL + '/')));
  }, [])
  return (<StaticQuery
    query={graphql`
      query {
        site {
          siteMetadata {
            title
            description
          }
        }
        sitePage {         
          path
          componentPath
        }
      }
    `}
    render={data => {
      return (
        <>
          <Helmet
            title={data.site.siteMetadata.title}
            meta={[
              { name: 'title', content: !tags[0] ? '' : tags[0].Titulo },
              // { name: 'description', content: !tags[0] ? '' : tags[0].Descripcion },
              { name: 'description', content: data.site.siteMetadata.description},
              { name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0' },
              { name: 'theme-color', content: '#ff5100' }
            ]}
          >
            <html lang="es-PE" />
          </Helmet>
          <Header siteTitle={data.site.siteMetadata.title} />
          <div className='flex direction-column justify-between' style={{ minHeight: '100vh' }}>
            <div>
              {children}
            </div>
            <Footer />
          </div>
        </>
      );


    }
    }
  />
  );

}


Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
